import MAYA from '../../../maya_api'
import {setLoadingContent} from '../../../layouts/Content/modules/loadingContent';
import {getStore} from "../../../main";
import _ from 'lodash'
import {USER_ROLES} from "../../../constants";

const LOAD_CLERKS_DEVICES = 'LOAD_CLERKS_DEVICES';
const LOAD_CLERKS = 'LOAD_CLERKS';
const ADD_NEW_CLERK = 'ADD_NEW_CLERK';
const SET_LOADING_FOR_CLERKS_ACTION = 'SET_LOADING_FOR_CLERKS_ACTION';
const OPEN_CLERK_MODAL = 'OPEN_CLERK_MODAL';
const OPEN_DEVICE_MODAL = 'OPEN_DEVICE_MODAL';
const OPEN_EDIT_DEVICE_MODAL = 'OPEN_EDIT_DEVICE_MODAL';
const OPEN_CLERK_CHANGE_PASSWORD_MODAL = 'OPEN_CLERK_CHANGE_PASSWORD_MODAL';
const OPEN_CLERK_EDIT_MODAL = 'OPEN_CLERK_EDIT_MODAL';
const SERVER_ERROR = 'SERVER_ERROR';
const ADD_NEW_DEVICE = 'ADD_NEW_DEVICE';
const SET_EDIT_DEVICE_INFO = 'SET_EDIT_DEVICE_INFO';
const CHANGE_ACTIVE_HISTORY_PAGE = 'CHANGE_ACTIVE_HISTORY_PAGE';
const SHOW_ONLY_ACTIVE_DEVICES = 'SHOW_ONLY_ACTIVE_DEVICES';
const CHANGE_PASSWORD_CLERK = 'CHANGE_PASSWORD_CLERK';
const EDIT_CLERK = 'EDIT_CLERK';
const SHOW_SUCCESS_RESPONSE = 'SHOW_SUCCESS_RESPONSE';

import {getLanguageScope} from '../../../helpers';
const _i18n = getLanguageScope('clerks_management');

function loadClerksDevices() {
  return async (dispatch, getStore) => {
    dispatch(setLoadingContent(true));

    const devices = await MAYA.getClerksDevices();
    const clerks = await MAYA.getStoreClerks();

    dispatch(setLoadingContent(false));

    dispatch({
      type: LOAD_CLERKS_DEVICES,
      payload: devices
    });

    dispatch({
      type: LOAD_CLERKS,
      payload: clerks
    })
  }
}

function updateDevice(device_id, field, value) {
  return async (dispatch, getStore) => {
    dispatch(setLoadingForClerksAction(true));

    const data = {[field]: value};
    const result = await MAYA.updateClerkDevice(device_id, data);
    let devices = getStore().clerks.clerkDevices;

    if (result) {

      const updateDevice = _.find(devices, {device_id});

      if (!updateDevice) {
        return devices
      }

      updateDevice[field] = value;
      devices = _.unionBy(devices, [updateDevice], 'device_id');

      dispatch(openEditDeviceModal(false));

      dispatch({
        type: LOAD_CLERKS_DEVICES,
        payload: devices
      })
    }

    dispatch(setLoadingForClerksAction(false));
  }
}

function createClerk(clerk) {
  return async (dispatch, getStore) => {
    dispatch(setLoadingForClerksAction(true));
    const result = await MAYA.createClerk(clerk);

    if (result.error) {
      dispatch(serverError({
        error: result.error,
        errorMessages: result.messages
      }))
    } else {
      dispatch({
        type: ADD_NEW_CLERK,
        payload: result
      });

      dispatch(openClerkModal(false))
    }

    dispatch(setLoadingForClerksAction(false));
  }
}

function createDevice(device) {
  return async (dispatch, getStore) => {
    dispatch(setLoadingForClerksAction(true));
    const result = await MAYA.createDevice(device);

    if (result) {
      dispatch({
        type: ADD_NEW_DEVICE,
        payload: {device_id: result.device_id, info: device.info, enabled: true, clerk_id: -1}
      });

      dispatch(openDeviceModal(false))
    }

    dispatch(setLoadingForClerksAction(false));
  }
}

function changePassword(data) {
  return async (dispatch, getStore) => {
    const clerks = getStore().clerks.clerks;
    let result = {};
    let role = USER_ROLES.STORE_CLERK;

    if(data && data.user_id){
      const user = _.find(clerks, (user) => user.id === data.user_id);
      role = user.role;
    }

    dispatch(setLoadingForClerksAction(true));

    if(role === USER_ROLES.STORE_CLERK){
      result = await MAYA.changePasswordClerk(data);
    }

    if(role === USER_ROLES.STORE_OWNER){
      result = await MAYA.changePasswordStoreOwner(data);
    }

    dispatch(setLoadingForClerksAction(false));

    dispatch({
      type: CHANGE_PASSWORD_CLERK
    });

    if(!result) return dispatch(serverError({
      error: _i18n('unexpected_error'),
      errorMessages: [_i18n('unexpected_error')]
    }));

    if (result.error) {
      return dispatch(serverError({
        error: result.error,
        errorMessages: result.messages || []
      }))
    }

    dispatch(showSuccessResponse(true));
  }
}

function editUser(modifier) {
  return async (dispatch, getStore) => {
    const clerks = getStore().clerks.clerks;
    let result = null;
    let role = USER_ROLES.STORE_CLERK;

    if(modifier && modifier.user_id){
      const user = _.find(clerks, (user) => user.id === modifier.user_id);
      role = user.role;
    }

    dispatch(setLoadingForClerksAction(true));

    if(role === USER_ROLES.STORE_CLERK){
      result = await MAYA.editClerk(modifier);
    }

    if(role === USER_ROLES.STORE_OWNER){
      result = await MAYA.editOwner(modifier);
    }

    dispatch(setLoadingForClerksAction(false));

    if(!result) return dispatch(serverError({
      error: _i18n('unexpected_error'),
      errorMessages: [_i18n('unexpected_error')]
    }));

    if (result.error) {
      return dispatch(serverError({
        error: result.error,
        errorMessages: result.messages || []
      }))
    }

    const data = result.response;
    if(!data) return dispatch(serverError({
      error: _i18n('unexpected_error'),
      errorMessages: [_i18n('unexpected_error')]
    }));

    let editedClerk = _.find(clerks, (c) => c.id === data.id);
    _.remove(clerks, (c) => c.id === data.id);

    clerks.push(_.extend(editedClerk, data));

    dispatch({
      type: EDIT_CLERK,
      payload: clerks
    });

    dispatch(showSuccessResponse(true));
  }
}

function serverError(input) {

  let errorObj = {};
  errorObj.error = input.error;
  errorObj.errorMessages = [input.error];

  if(input.errorMessages && input.errorMessages.length){
    errorObj.errorMessages = input.errorMessages
  }

  return (dispatch, getStore) => {
    dispatch({
      type: SERVER_ERROR,
      payload: errorObj
    })
  }
}

function showSuccessResponse(status) {
  return (dispatch, getStore) => {
    dispatch({
      type: SHOW_SUCCESS_RESPONSE,
      payload: status
    })
  }
}

function setLoadingForClerksAction(payload) {
  return (dispatch, getStore) => {
    dispatch({
      type: SET_LOADING_FOR_CLERKS_ACTION,
      payload
    })
  }
}

function openClerkModal(payload) {
  return {
    type: OPEN_CLERK_MODAL,
    payload
  }
}

function openDeviceModal(payload) {
  return {
    type: OPEN_DEVICE_MODAL,
    payload
  }
}

function openEditDeviceModal(payload) {
  return {
    type: OPEN_EDIT_DEVICE_MODAL,
    payload
  }
}

function openClerkChangePasswordModal(payload) {
  return {
    type: OPEN_CLERK_CHANGE_PASSWORD_MODAL,
    payload
  }
}

function openClerkEditModal(payload) {
  return {
    type: OPEN_CLERK_EDIT_MODAL,
    payload
  }
}

function setEditDeviceInfo(payload) {
  return {
    type: SET_EDIT_DEVICE_INFO,
    payload
  }
}

function changeActiveHistoryPage(value = 1) {
  return {
    type: CHANGE_ACTIVE_HISTORY_PAGE,
    payload: value
  }
}

function showOnlyActiveDevices(value) {
  return {
    type: SHOW_ONLY_ACTIVE_DEVICES,
    payload: value
  }
}

export {
  loadClerksDevices,
  updateDevice,
  createClerk,
  changePassword,
  editUser,
  serverError,
  createDevice,
  setEditDeviceInfo,
  changeActiveHistoryPage,
  showOnlyActiveDevices,
  showSuccessResponse,
  openClerkModal,
  openDeviceModal,
  openEditDeviceModal,
  openClerkChangePasswordModal,
  openClerkEditModal
}

const initialState = {
  clerkDevices: [],
  clerks: [],
  deviceChanged: {},
  serverError: '',
  errorMessages: [],
  setLoading: false,
  activePage: 1,
  onlyActiveDevices: false,
  showSuccessResponse: false,

  openClerkModal: false,
  openDeviceModal: false,
  openClerkEditModal: false,
  openClerkChangePasswordModal: false
};

const ACTION_HANDLERS = {
  [LOAD_CLERKS_DEVICES]: (state, action) => ({
    ...state, clerkDevices: action.payload
  }),
  [LOAD_CLERKS]: (state, action) => ({
    ...state, clerks: action.payload
  }),
  [SERVER_ERROR]: (state, action) => ({
    ...state, serverError: action.payload.error, errorMessages: action.payload.errorMessages
  }),
  [ADD_NEW_CLERK]: (state, action) => ({
    ...state, clerks: [...state.clerks, action.payload]
  }),
  [ADD_NEW_DEVICE]: (state, action) => ({
    ...state, clerkDevices: [...state.clerkDevices, action.payload]
  }),
  [SET_LOADING_FOR_CLERKS_ACTION]: (state, action) => ({
    ...state, setLoading: action.payload
  }),
  [OPEN_CLERK_MODAL]: (state, action) => ({
    ...state, openClerkModal: action.payload
  }),
  [OPEN_DEVICE_MODAL]: (state, action) => ({
    ...state, openDeviceModal: action.payload
  }),
  [OPEN_EDIT_DEVICE_MODAL]: (state, action) => ({
    ...state, openEditDeviceModal: action.payload
  }),
  [OPEN_CLERK_CHANGE_PASSWORD_MODAL]: (state, action) => ({
    ...state, openClerkChangePasswordModal: action.payload
  }),
  [OPEN_CLERK_EDIT_MODAL]: (state, action) => ({
    ...state, openClerkEditModal: action.payload
  }),
  [SET_EDIT_DEVICE_INFO]: (state, action) => ({
    ...state, deviceChanged: action.payload
  }),
  [CHANGE_ACTIVE_HISTORY_PAGE]: (state, action) => ({
    ...state,
    activePage: action.payload
  }),
  [SHOW_ONLY_ACTIVE_DEVICES]: (state, action) => ({
    ...state,
    onlyActiveDevices: action.payload
  }),
  [SHOW_SUCCESS_RESPONSE]: (state, action) => ({
    ...state, showSuccessResponse: action.payload
  }),
  [CHANGE_PASSWORD_CLERK]: (state) => state,
  [EDIT_CLERK]: (state, action) => ({
    ...state, clerks: action.payload
  })
};

export default function clerkReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}




// WEBPACK FOOTER //
// ./src/components/Clerks/modules/clerks.js